import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {UpdatePasswordContextProvider} from '../../components/UpdatePasswordContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import FieldPassword from '../../components/FieldPassword';
import FieldConfirmPassword from '../../components/FieldConfirmPassword';
import ButtonUpdatePassword from '../../components/ButtonUpdatePassword';
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import styles from './UpdatePassword.module.scss';

const UpdatePassword = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'update-password-page-header'}
        defaultMessage={'Update password'}
        showLogo={true}
      />
    ));
  }, []);

  return (
    <UpdatePasswordContextProvider>
      <SectionPanel className={styles.updatePasswordContainer}>
        <div className={styles.message}>
          <FormattedMessage
            id={'update-password-message'}
            defaultMessage={'Please enter and confirm your new password'}
          />
        </div>
        <FieldPassword/>
        <FieldConfirmPassword/>
        <ButtonUpdatePassword/>
      </SectionPanel>
      <FooterLogo/>
    </UpdatePasswordContextProvider>
  );
};

export default UpdatePassword;
